/**
 * Sternbild-Linien für NATURMACHER Sternkarten
 * Definiert Verbindungslinien zwischen Sternen zur Darstellung von Sternbildern
 * Koordinaten: J2000.0 Äquatorial (RA/Dec in Grad)
 * Format: [[RA1, DEC1], [RA2, DEC2]]
 */

// Standard-Sternbild-Linien - Vollständiger Katalog
const standardConstellationLines = [
  // Großer Wagen (Ursa Major) - Index 0-6
  [[165.93, 61.75], [165.46, 56.38]], // Dubhe - Merak
  [[165.46, 56.38], [178.46, 53.69]], // Merak - Phecda
  [[178.46, 53.69], [183.86, 57.03]], // Phecda - Megrez
  [[183.86, 57.03], [193.51, 55.96]], // Megrez - Alioth
  [[193.51, 55.96], [200.98, 54.93]], // Alioth - Mizar
  [[200.98, 54.93], [206.89, 49.31]], // Mizar - Alkaid
  [[183.86, 57.03], [165.93, 61.75]], // Megrez - Dubhe
  
  // Kassiopeia - Index 7-10
  [[2.30, 59.15], [10.13, 56.54]], // Caph - Schedar
  [[10.13, 56.54], [14.18, 60.72]], // Schedar - Gamma Cas
  [[14.18, 60.72], [22.82, 57.81]], // Gamma Cas - Ruchbah
  [[22.82, 57.81], [25.65, 63.67]], // Ruchbah - Segin
  
  // Orion (vollständig) - Index 11-20
  [[83.00, -0.30], [84.05, -1.20]], // Mintaka - Alnilam (Gürtel)
  [[84.05, -1.20], [85.19, -1.94]], // Alnilam - Alnitak (Gürtel)
  [[81.28, 6.35], [83.00, -0.30]], // Bellatrix - Mintaka
  [[88.79, 7.41], [85.19, -1.94]], // Betelgeuse - Alnitak
  [[81.28, 6.35], [88.79, 7.41]], // Bellatrix - Betelgeuse (Schultern)
  [[78.63, -8.20], [83.00, -0.30]], // Rigel - Mintaka
  [[86.94, -9.67], [85.19, -1.94]], // Saiph - Alnitak
  [[78.63, -8.20], [86.94, -9.67]], // Rigel - Saiph (Füße)
  [[81.28, 6.35], [78.63, -8.20]], // Bellatrix - Rigel (linke Seite)
  [[88.79, 7.41], [86.94, -9.67]], // Betelgeuse - Saiph (rechte Seite)
  
  // Kleiner Wagen (Ursa Minor) - Index 21-23
  [[37.95, 89.26], [222.68, 74.16]], // Polaris - Kochab
  [[222.68, 74.16], [230.18, 71.83]], // Kochab - Pherkad
  [[230.18, 71.83], [37.95, 89.26]], // Pherkad - Polaris
  
  // Zwillinge (Gemini) erweitert - Index 24-29
  [[113.65, 31.89], [116.33, 28.03]], // Castor - Pollux (Köpfe)
  [[116.33, 28.03], [115.56, 16.40]], // Pollux - Alhena
  [[113.65, 31.89], [115.56, 16.40]], // Castor - Alhena
  [[113.65, 31.89], [105.69, 25.13]], // Castor - Mebsuta (Körper)
  [[116.33, 28.03], [109.78, 22.00]], // Pollux - Wasat (Körper)
  [[95.99, 22.51], [105.69, 25.13]], // Tejat - Mebsuta (Füße)
  
  // Löwe (Leo) erweitert - Index 30-36
  [[152.09, 11.97], [154.99, 19.84]], // Regulus - Algieba (Kopf)
  [[154.99, 19.84], [177.26, 14.57]], // Algieba - Denebola (Rücken)
  [[177.26, 14.57], [152.09, 11.97]], // Denebola - Regulus (Bauch)
  [[152.09, 11.97], [156.52, 23.42]], // Regulus - Adhafera (Mähne)
  [[154.99, 19.84], [169.62, 20.52]], // Algieba - Zosma (Rücken)
  [[169.62, 20.52], [177.26, 14.57]], // Zosma - Denebola
  [[165.42, 15.43], [169.62, 20.52]], // Chertan - Zosma (Hüfte)
  
  // Adler (Aquila) - Index 37-38
  [[297.70, 8.87], [295.42, 10.61]], // Altair - Tarazed
  [[297.70, 8.87], [299.09, 6.41]], // Altair - Alshain
  
  // Schwan (Cygnus) Basis - Index 39-40
  [[310.36, 45.28], [305.56, 40.26]], // Deneb - Sadr
  [[305.56, 40.26], [292.68, 27.96]], // Sadr - Albireo
  
  // Leier (Lyra) Basis - Index 41
  [[279.23, 38.78], [284.74, 33.36]], // Vega - Sheliak
  
  // Perseus Basis - Index 42
  [[51.08, 49.86], [47.04, 40.96]], // Mirfak - Algol
  
  // Andromeda - Index 43-44
  [[2.10, 29.09], [17.43, 35.62]], // Alpheratz - Mirach
  [[17.43, 35.62], [31.79, 42.33]], // Mirach - Almach
  
  // Pegasus - Index 45-47
  [[346.19, 15.21], [345.94, 28.08]], // Markab - Scheat
  [[345.94, 28.08], [3.31, 15.18]], // Scheat - Algenib
  [[3.31, 15.18], [2.10, 29.09]], // Algenib - Alpheratz
  
  // Drachen (Draco) - Index 48-52
  [[269.15, 51.49], [263.05, 52.30]], // Eltanin - Rastaban
  [[263.05, 52.30], [211.10, 64.38]], // Rastaban - Thuban
  [[211.10, 64.38], [286.41, 67.66]], // Thuban - Kuma
  [[286.41, 67.66], [358.67, 77.63]], // Kuma - Errai
  [[358.67, 77.63], [319.64, 62.59]], // Errai - Alderamin
  
  // Schwan (Cygnus) erweitert - Index 53-57
  [[305.56, 40.26], [304.01, 33.97]], // Sadr - Gienah Cyg
  [[305.56, 40.26], [344.41, 70.56]], // Sadr - Alfirk
  [[310.36, 45.28], [284.74, 33.36]], // Deneb - Sheliak
  [[284.74, 33.36], [284.74, 32.69]], // Sheliak - Sulafat
  [[284.74, 32.69], [279.23, 38.78]], // Sulafat - Vega
  
  // Fuhrmann (Auriga) - Index 58-62
  [[79.17, 45.99], [89.88, 44.95]], // Capella - Menkalinan
  [[89.88, 44.95], [81.57, 28.61]], // Menkalinan - Elnath
  [[81.57, 28.61], [76.63, 41.23]], // Elnath - Hoedus I
  [[76.63, 41.23], [77.84, 41.50]], // Hoedus I - Hoedus II
  [[77.84, 41.50], [79.17, 45.99]], // Hoedus II - Capella
  
  // Dreieck (Triangulum) - Index 63-65
  [[31.79, 29.58], [34.26, 34.99]], // Mothallah - Beta Tri
  [[34.26, 34.99], [27.72, 19.29]], // Beta Tri - Mesarthim
  [[27.72, 19.29], [31.79, 29.58]], // Mesarthim - Mothallah
  
  // Jungfrau (Virgo) - Index 66-70
  [[201.30, -11.16], [177.67, 1.77]], // Spica - Zavijava
  [[177.67, 1.77], [190.42, -1.45]], // Zavijava - Porrima
  [[190.42, -1.45], [195.54, 10.96]], // Porrima - Vindemiatrix
  [[195.54, 10.96], [185.19, 17.53]], // Vindemiatrix - Diadem
  [[185.19, 17.53], [177.67, 1.77]], // Diadem - Zavijava
  
  // Nördliche Krone (Corona Borealis) - Index 71
  [[233.67, 26.71], [240.08, 36.49]], // Alphecca - Nusakan
  
  // Leier (Lyra) erweitert - Index 72-75
  [[279.23, 38.78], [284.74, 32.69]], // Vega - Sulafat
  [[284.74, 32.69], [284.74, 33.36]], // Sulafat - Sheliak
  [[284.74, 33.36], [279.23, 38.78]], // Sheliak - Vega
  [[279.23, 38.78], [281.42, 35.25]], // Vega - Epsilon Lyrae
  
  // Perseus Y-Form - Index 76-79
  [[51.08, 49.86], [55.90, 55.90]], // Mirfak - Atik
  [[51.08, 49.86], [59.74, 35.79]], // Mirfak - Menkib
  [[47.04, 40.96], [31.79, 42.33]], // Algol - Almach
  [[47.04, 40.96], [55.90, 55.90]], // Algol - Atik
  
  // Großer Bär Körper - Index 80-84
  [[165.93, 61.75], [134.80, 48.04]], // Dubhe - Talitha
  [[134.80, 48.04], [143.57, 41.50]], // Talitha - Tania Australis
  [[143.57, 41.50], [165.93, 31.53]], // Tania Australis - Alula Australis
  [[165.93, 31.53], [178.46, 53.69]], // Alula Australis - Phecda
  [[146.88, 34.21], [143.57, 41.50]], // Praecipua - Tania Australis
  
  // Stier (Taurus) - Index 85-92
  [[68.98, 16.51], [81.57, 28.61]], // Aldebaran - Elnath
  [[68.98, 16.51], [56.87, 24.11]], // Aldebaran - Alcyone (Plejaden)
  [[56.87, 24.11], [56.30, 24.05]], // Alcyone - Atlas
  [[56.30, 24.05], [56.22, 24.11]], // Atlas - Electra
  [[56.22, 24.11], [56.46, 24.37]], // Electra - Maia
  [[56.46, 24.37], [57.29, 23.95]], // Maia - Merope
  [[57.29, 23.95], [56.30, 24.47]], // Merope - Taygeta
  [[56.30, 24.47], [56.87, 24.11]], // Taygeta - Alcyone
  
  // Krebs (Cancer) - Index 93-96
  [[134.62, 11.86], [136.04, 9.19]], // Acubens - Al Tarf
  [[136.04, 9.19], [131.17, 19.85]], // Al Tarf - Asellus Borealis
  [[131.17, 19.85], [130.82, 18.15]], // Asellus Borealis - Asellus Australis
  [[130.82, 18.15], [134.62, 11.86]], // Asellus Australis - Acubens
  
  // Skorpion (Scorpius) erweitert - Index 97-101
  [[247.35, -26.43], [240.08, -22.62]], // Antares - Tau Sco
  [[240.08, -22.62], [244.58, -19.80]], // Tau Sco - Delta Sco
  [[244.58, -19.80], [263.40, -37.10]], // Delta Sco - Shaula
  [[263.40, -37.10], [264.33, -43.00]], // Shaula - Sargas
  [[264.33, -43.00], [247.35, -26.43]], // Sargas - Antares
  
  // Schütze (Sagittarius) erweitert - Index 102-106
  [[276.04, -34.38], [283.82, -26.30]], // Kaus Australis - Nunki
  [[283.82, -26.30], [290.97, -29.88]], // Nunki - Ascella
  [[290.97, -29.88], [284.74, -25.42]], // Ascella - Kaus Media
  [[284.74, -25.42], [279.23, -30.42]], // Kaus Media - Kaus Borealis
  [[279.23, -30.42], [276.04, -34.38]], // Kaus Borealis - Kaus Australis
  
  // Steinbock (Capricornus) - Index 107-110
  [[325.02, -16.13], [304.51, -12.51]], // Deneb Algedi - Algedi
  [[304.51, -12.51], [305.25, -14.78]], // Algedi - Dabih
  [[305.25, -14.78], [322.89, -16.66]], // Dabih - Nashira
  [[322.89, -16.66], [325.02, -16.13]], // Nashira - Deneb Algedi
  
  // Wassermann (Aquarius) - Index 111-113
  [[322.89, -5.57], [331.45, -0.32]], // Sadalsuud - Sadalmelik
  [[331.45, -0.32], [348.96, 6.86]], // Sadalmelik - Fum al Samakah
  [[348.96, 6.86], [322.89, -5.57]], // Fum al Samakah - Sadalsuud
  
  // Kepheus (Cepheus) - Index 114-117
  [[319.64, 62.59], [344.41, 70.56]], // Alderamin - Alfirk
  [[344.41, 70.56], [358.67, 77.63]], // Alfirk - Errai
  [[358.67, 77.63], [342.52, 66.20]], // Errai - Iota Cep
  [[342.52, 66.20], [319.64, 62.59]], // Iota Cep - Alderamin
  
  // Eidechse (Lacerta) - Index 118
  [[344.41, 70.56], [338.16, 50.28]], // Alfirk - Alpha Lac
  
  // Kreuz des Südens (Crux) - Index 119-120
  [[186.65, -63.10], [191.93, -59.69]], // Acrux - Gacrux
  [[188.92, -57.11], [195.30, -60.40]], // Mimosa - Delta Cru
  
  // Zentaur (Centaurus) - Index 121-122
  [[219.90, -60.83], [210.96, -36.37]], // Rigil Kent - Hadar
  [[210.96, -36.37], [165.46, -47.29]], // Hadar - Menkent
  
  // Jagdhunde (Canes Venatici) - Index 123
  [[194.01, 38.32], [188.44, 41.36]], // Cor Caroli - Chara
  
  // Haar der Berenike (Coma Berenices) - Index 124
  [[185.19, 17.53], [183.95, 21.77]], // Diadem - Beta Com
  
  // Winter-Dreieck - Index 125-127
  [[88.79, 7.41], [101.29, -16.72]], // Betelgeuse - Sirius
  [[101.29, -16.72], [114.83, 5.22]], // Sirius - Procyon
  [[114.83, 5.22], [88.79, 7.41]], // Procyon - Betelgeuse
  
  // Sommer-Dreieck - Index 128-130
  [[279.23, 38.78], [297.70, 8.87]], // Vega - Altair
  [[297.70, 8.87], [310.36, 45.28]], // Altair - Deneb
  [[310.36, 45.28], [279.23, 38.78]], // Deneb - Vega
  
  // Navigation-Linien - Index 131-132
  [[165.93, 61.75], [37.95, 89.26]], // Dubhe - Polaris (Polweiser)
  [[165.46, 56.38], [37.95, 89.26]], // Merak - Polaris (Polweiser)
];

/**
 * Sternbild-Linien für Tierkreiszeichen (vereinfacht)
 * Wird verwendet für die Hervorhebung des aktuellen Sternzeichens
 */
function getConstellationLines(zodiacSign) {
  const constellations = {
    'Steinbock': [
      [[325.02, -16.13], [304.51, -12.51]], // Deneb Algedi - Algedi
      [[304.51, -12.51], [305.25, -14.78]], // Algedi - Dabih
    ],
    'Wassermann': [
      [[322.89, -5.57], [331.45, -0.32]], // Sadalsuud - Sadalmelik
      [[331.45, -0.32], [348.96, 6.86]], // Sadalmelik - Fum al Samakah
    ],
    'Fische': [
      [[24.50, 2.76], [348.96, 6.86]], // Alrescha - Fum al Samakah
    ],
    'Widder': [
      [[31.79, 23.46], [28.66, 20.81]], // Hamal - Sheratan
      [[28.66, 20.81], [27.72, 19.29]], // Sheratan - Mesarthim
    ],
    'Stier': [
      [[68.98, 16.51], [81.57, 28.61]], // Aldebaran - Elnath
    ],
    'Zwillinge': [
      [[113.65, 31.89], [116.33, 28.03]], // Castor - Pollux
    ],
    'Krebs': [
      [[134.62, 11.86], [136.04, 9.19]], // Acubens - Al Tarf
    ],
    'Löwe': [
      [[152.09, 11.97], [177.26, 14.57]], // Regulus - Denebola
      [[152.09, 11.97], [154.99, 19.84]], // Regulus - Algieba
    ],
    'Jungfrau': [
      [[201.30, -11.16], [177.67, 1.77]], // Spica - Zavijava
      [[177.67, 1.77], [190.42, -1.45]], // Zavijava - Porrima
    ],
    'Waage': [
      [[222.72, -16.04], [229.25, -9.38]], // Zubenelgenubi - Zubeneschamali
    ],
    'Skorpion': [
      [[247.35, -26.43], [263.40, -37.10]], // Antares - Shaula
      [[263.40, -37.10], [264.33, -43.00]], // Shaula - Sargas
    ],
    'Schütze': [
      [[276.04, -34.38], [283.82, -26.30]], // Kaus Australis - Nunki
      [[283.82, -26.30], [290.97, -29.88]], // Nunki - Ascella
    ]
  };
  
  return constellations[zodiacSign] || [];
}

/**
 * Sternbild-Daten mit deutschen Namen und Linienzuordnung
 */
const constellationData = [
  { name: 'Großer Wagen', germanName: 'Großer Wagen', lines: standardConstellationLines.slice(0, 7) },
  { name: 'Kassiopeia', germanName: 'Kassiopeia', lines: standardConstellationLines.slice(7, 11) },
  { name: 'Orion', germanName: 'Orion', lines: standardConstellationLines.slice(11, 21) },
  { name: 'Kleiner Wagen', germanName: 'Kleiner Wagen', lines: standardConstellationLines.slice(21, 24) },
  { name: 'Zwillinge', germanName: 'Zwillinge', lines: standardConstellationLines.slice(24, 30) },
  { name: 'Löwe', germanName: 'Löwe', lines: standardConstellationLines.slice(30, 37) },
  { name: 'Adler', germanName: 'Adler', lines: standardConstellationLines.slice(37, 39) },
  { name: 'Schwan', germanName: 'Schwan', lines: standardConstellationLines.slice(39, 41) },
  { name: 'Leier', germanName: 'Leier', lines: standardConstellationLines.slice(41, 42) },
  { name: 'Perseus', germanName: 'Perseus', lines: standardConstellationLines.slice(42, 43) },
  { name: 'Andromeda', germanName: 'Andromeda', lines: standardConstellationLines.slice(43, 45) },
  { name: 'Pegasus', germanName: 'Pegasus', lines: standardConstellationLines.slice(45, 48) },
  { name: 'Drachen', germanName: 'Draco', lines: standardConstellationLines.slice(48, 53) },
  { name: 'Schwan Erweitert', germanName: 'Cygnus', lines: standardConstellationLines.slice(53, 58) },
  { name: 'Fuhrmann', germanName: 'Auriga', lines: standardConstellationLines.slice(58, 63) },
  { name: 'Dreieck', germanName: 'Triangulum', lines: standardConstellationLines.slice(63, 66) },
  { name: 'Jungfrau', germanName: 'Virgo', lines: standardConstellationLines.slice(66, 71) },
  { name: 'Nördliche Krone', germanName: 'Corona Borealis', lines: standardConstellationLines.slice(71, 72) },
  { name: 'Leier Erweitert', germanName: 'Lyra', lines: standardConstellationLines.slice(72, 76) },
  { name: 'Perseus Y-Form', germanName: 'Perseus', lines: standardConstellationLines.slice(76, 80) },
  { name: 'Großer Bär Körper', germanName: 'Ursa Major', lines: standardConstellationLines.slice(80, 85) },
  { name: 'Stier', germanName: 'Taurus', lines: standardConstellationLines.slice(85, 93) },
  { name: 'Krebs', germanName: 'Cancer', lines: standardConstellationLines.slice(93, 97) },
  { name: 'Skorpion Erweitert', germanName: 'Scorpius', lines: standardConstellationLines.slice(97, 102) },
  { name: 'Schütze Erweitert', germanName: 'Sagittarius', lines: standardConstellationLines.slice(102, 107) },
  { name: 'Steinbock', germanName: 'Capricornus', lines: standardConstellationLines.slice(107, 111) },
  { name: 'Wassermann', germanName: 'Aquarius', lines: standardConstellationLines.slice(111, 114) },
  { name: 'Kepheus', germanName: 'Cepheus', lines: standardConstellationLines.slice(114, 118) },
  { name: 'Eidechse', germanName: 'Lacerta', lines: standardConstellationLines.slice(118, 119) },
  { name: 'Kreuz des Südens', germanName: 'Crux', lines: standardConstellationLines.slice(119, 121) },
  { name: 'Zentaur', germanName: 'Centaurus', lines: standardConstellationLines.slice(121, 123) },
  { name: 'Jagdhunde', germanName: 'Canes Venatici', lines: standardConstellationLines.slice(123, 124) },
  { name: 'Haar der Berenike', germanName: 'Coma Berenices', lines: standardConstellationLines.slice(124, 125) },
  { name: 'Winter-Dreieck', germanName: 'Winter Triangle', lines: standardConstellationLines.slice(125, 128) },
  { name: 'Sommer-Dreieck', germanName: 'Summer Triangle', lines: standardConstellationLines.slice(128, 131) },
  { name: 'Navigation', germanName: 'Star Paths', lines: standardConstellationLines.slice(131, 133) }
];

/**
 * Sternbild-Beschreibungen für Tooltips
 */
const constellationDescriptions = {
  'Großer Wagen': 'Teil des Großen Bären, enthält den Polweiser-Stern Dubhe und Merak',
  'Kassiopeia': 'Das "Himmels-W", zirkumpolar und immer sichtbar',
  'Orion': 'Der Himmelsjäger mit den berühmten Gürtelsternen',
  'Kleiner Wagen': 'Enthält den Polarstern, um den sich der Himmel dreht',
  'Zwillinge': 'Die Zwillingsbrüder Castor und Pollux',
  'Löwe': 'Das Sternbild des Löwen mit dem hellen Stern Regulus',
  'Adler': 'Der Adler mit dem hellen Stern Altair',
  'Schwan': 'Der Schwan, auch "Kreuz des Nordens" genannt',
  'Leier': 'Die Leier mit dem hellen Stern Vega',
  'Perseus': 'Der Held Perseus mit dem veränderlichen Stern Algol',
  'Andromeda': 'Die Prinzessin Andromeda',
  'Pegasus': 'Das geflügelte Pferd mit dem markanten Herbstviereck',
  'Drachen': 'Der Drache windet sich um den Himmelspol',
  'Fuhrmann': 'Der Fuhrmann mit dem hellen Stern Capella',
  'Dreieck': 'Ein kleines, aber markantes Sternbild',
  'Jungfrau': 'Die Jungfrau mit dem hellen Stern Spica',
  'Nördliche Krone': 'Die Krone der Ariadne',
  'Stier': 'Der Stier mit dem Sternhaufen der Plejaden',
  'Krebs': 'Der Krebs mit dem Praesepe-Sternhaufen',
  'Skorpion': 'Der Skorpion mit dem roten Riesen Antares',
  'Schütze': 'Der Schütze zeigt zum Zentrum der Milchstraße',
  'Steinbock': 'Der Steinbock am südlichen Himmel',
  'Wassermann': 'Der Wasserträger',
  'Kepheus': 'Der König Kepheus',
  'Winter-Dreieck': 'Markante Formation aus Betelgeuse, Sirius und Procyon',
  'Sommer-Dreieck': 'Markante Formation aus Vega, Altair und Deneb'
};

// Export für Verwendung in anderen Dateien
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { 
    standardConstellationLines,
    getConstellationLines,
    constellationData,
    constellationDescriptions 
  };
}